export const css = /* css */ `
:host,
:host *,
*::before,
*::after {
  box-sizing: border-box;
}
a {
  color: inherit;
}
:not(.focus-visible),
:host(:not(.focus-visible)) {
  outline: none;
}
[hidden] {
  display: none !important;
}
:host {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  margin: 0;
  display: inline;
  font-family: 'Material Icons', sans-serif;
  font-weight: normal;
  font-style: normal;
  display: none;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  vertical-align: middle;
  font-feature-settings: 'liga';
}
:host([loaded]) {
  display: inline-block;
}
`;